/**
 * Wallet/web3 wiring for the dashboard.
 *
 * `createAutheWagmiConfig` derives the EVM chain list + transports straight from
 * the shared `@authe/fe-commons` chain registry (so the wallet can only ever talk
 * to chains the platform supports) and defaults to the injected (browser-
 * extension) connector. Built once as a module singleton — wagmi configs are
 * stateful and must not be recreated on re-render.
 */
import { createAutheWagmiConfig } from "@authe/web3";

export const wagmiConfig = createAutheWagmiConfig({
  // Reconnect-friendly storage/hydration; harmless in a pure SPA.
  ssr: false,
});
